export enum FundamentalValuationsType {
    RATIO = 'Ratio',
    PERCENT = 'Percent',
    VALUE = 'Value',
    NUMBER = 'Number',
    DATE = 'Date',
    METADATA = 'Metadata',
    INCLUDE = 'Include',
    EXCLUDE = 'Exclude',
}

const { VALUE, RATIO, PERCENT, DATE, METADATA, INCLUDE, EXCLUDE } = FundamentalValuationsType;

export const schema: Record<string, any> = {
    symbol: METADATA,
    date: DATE,
    calendarYear: DATE,
    period: METADATA,
    currentRatio: RATIO,
    quickRatio: RATIO,
    cashRatio: RATIO,
    daysOfSalesOutstanding: RATIO,
    daysOfInventoryOutstanding: RATIO,
    operatingCycle: RATIO,
    daysOfPayablesOutstanding: RATIO,
    cashConversionCycle: RATIO,
    grossProfitMargin: PERCENT,
    operatingProfitMargin: PERCENT,
    pretaxProfitMargin: PERCENT,
    netProfitMargin: PERCENT,
    effectiveTaxRate: PERCENT,
    returnOnAssets: PERCENT,
    returnOnEquity: PERCENT,
    returnOnCapitalEmployed: PERCENT,
    netIncomePerEBT: RATIO,
    ebtPerEbit: RATIO,
    ebitPerRevenue: RATIO,
    debtRatio: RATIO,
    debtEquityRatio: RATIO,
    longTermDebtToCapitalization: RATIO,
    totalDebtToCapitalization: RATIO,
    interestCoverage: RATIO,
    cashFlowToDebtRatio: RATIO,
    companyEquityMultiplier: RATIO,
    receivablesTurnover: RATIO,
    payablesTurnover: RATIO,
    inventoryTurnover: RATIO,
    fixedAssetTurnover: RATIO,
    assetTurnover: RATIO,
    operatingCashFlowPerShare: RATIO,
    freeCashFlowPerShare: RATIO,
    cashPerShare: RATIO,
    payoutRatio: RATIO,
    operatingCashFlowSalesRatio: RATIO,
    freeCashFlowOperatingCashFlowRatio: RATIO,
    cashFlowCoverageRatios: RATIO,
    shortTermCoverageRatios: RATIO,
    capitalExpenditureCoverageRatio: RATIO,
    dividendPaidAndCapexCoverageRatio: RATIO,
    dividendPayoutRatio: RATIO,
    priceBookValueRatio: RATIO,
    priceToBookRatio: RATIO,
    priceToSalesRatio: RATIO,
    priceEarningsRatio: RATIO,
    priceToFreeCashflowsRatio: RATIO,
    priceToOperatingCashflowsRatio: RATIO,
    priceCashFlowRatio: RATIO,
    priceEarningsToGrowthRatio: RATIO,
    priceSalesRatio: RATIO,
    dividendYield: PERCENT,
    enterpriseValueMultiple: RATIO,
    priceFairValue: VALUE,
    // Capital Structure - Key Metrics
    revenuePerShare: VALUE,
    netIncomePerShare: VALUE,
    // operatingCashFlowPerShare: VALUE,
    // freeCashFlowPerShare: VALUE,
    // cashPerShare: VALUE,
    bookValuePerShare: VALUE,
    tangibleBookValuePerShare: VALUE,
    shareholdersEquityPerShare: VALUE,
    interestDebtPerShare: VALUE,
    marketCap: VALUE,
    enterpriseValue: VALUE,
    peRatio: VALUE,
    // priceToSalesRatio: VALUE,
    pocfratio: VALUE,
    pfcfRatio: VALUE,
    pbRatio: VALUE,
    ptbRatio: VALUE,
    evToSales: VALUE,
    enterpriseValueOverEBITDA: VALUE,
    evToOperatingCashFlow: VALUE,
    evToFreeCashFlow: VALUE,
    earningsYield: VALUE,
    freeCashFlowYield: VALUE,
    debtToEquity: VALUE,
    debtToAssets: VALUE,
    netDebtToEBITDA: VALUE,
    // currentRatio: VALUE,
    // interestCoverage: VALUE,
    incomeQuality: VALUE,
    // dividendYield: VALUE,
    // payoutRatio: VALUE,
    salesGeneralAndAdministrativeToRevenue: VALUE,
    researchAndDdevelopementToRevenue: VALUE,
    intangiblesToTotalAssets: VALUE,
    capexToOperatingCashFlow: VALUE,
    capexToRevenue: VALUE,
    capexToDepreciation: VALUE,
    stockBasedCompensationToRevenue: VALUE,
    grahamNumber: VALUE,
    roic: VALUE,
    returnOnTangibleAssets: VALUE,
    grahamNetNet: VALUE,
    workingCapital: VALUE,
    tangibleAssetValue: VALUE,
    netCurrentAssetValue: VALUE,
    investedCapital: VALUE,
    averageReceivables: VALUE,
    averagePayables: VALUE,
    averageInventory: VALUE,
    daysSalesOutstanding: VALUE,
    daysPayablesOutstanding: VALUE,
    daysOfInventoryOnHand: VALUE,
    // receivablesTurnover: VALUE,
    // payablesTurnover: VALUE,
    // inventoryTurnover: VALUE,
    roe: VALUE,
    capexPerShare: VALUE,
    // Returns - Income
    growthRevenue: PERCENT,
    growthCostOfRevenue: PERCENT,
    growthGrossProfit: PERCENT,
    growthGrossProfitRatio: PERCENT,
    growthResearchAndDevelopmentExpenses: PERCENT,
    growthGeneralAndAdministrativeExpenses: PERCENT,
    growthSellingGeneralAndAdministrativeExpenses: PERCENT,
    growthSellingAndMarketingExpenses: PERCENT,
    growthOtherExpenses: PERCENT,
    growthOperatingExpenses: PERCENT,
    growthCostAndExpenses: PERCENT,
    growthInterestExpense: PERCENT,
    growthInterestIncome: PERCENT,
    growthDepreciationAndAmortization: PERCENT,
    growthEbitda: PERCENT,
    growthEbitdaRatio: PERCENT,
    growthOperatingIncome: PERCENT,
    growthOperatingIncomeRatio: PERCENT,
    growthTotalOtherIncomeExpensesNet: PERCENT,
    growthIncomeBeforeTax: PERCENT,
    growthIncomeBeforeTaxRatio: PERCENT,
    growthIncomeTaxExpense: PERCENT,
    growthNetIncome: PERCENT,
    growthNetIncomeRatio: PERCENT,
    growthEps: PERCENT,
    growthEpsdiluted: PERCENT,
    growthWeightedAverageShsOut: PERCENT,
    growthWeightedAverageShsOutDil: PERCENT,
    // Returns - Balance Sheet
    // growthCashAndCashEquivalents: PERCENT,
    // growthShortTermInvestments: PERCENT,
    // growthCashAndShortTermInvestments: PERCENT,
    // growthNetReceivables: PERCENT,
    // growthInventory: PERCENT,
    // growthPreferredStock: PERCENT,
    // growthOtherCurrentAssets: PERCENT,
    // growthTotalCurrentAssets: PERCENT,
    // growthPropertyPlantEquipmentNet: PERCENT,
    // growthGoodwill: PERCENT,
    // growthIntangibleAssets: PERCENT,
    // growthGoodwillAndIntangibleAssets: PERCENT,
    // growthLongTermInvestments: PERCENT,
    // growthTaxAssets: PERCENT,
    // growthOtherNonCurrentAssets: PERCENT,
    // growthTotalNonCurrentAssets: PERCENT,
    // growthOtherAssets: PERCENT,
    // growthTotalAssets: PERCENT,
    // growthAccountPayables: PERCENT,
    // growthShortTermDebt: PERCENT,
    // growthTaxPayables: PERCENT,
    // growthCapitalLeaseObligations: PERCENT,
    // growthDeferredRevenue: PERCENT,
    // growthOtherCurrentLiabilities: PERCENT,
    // growthTotalCurrentLiabilities: PERCENT,
    // growthLongTermDebt: PERCENT,
    // growthDeferredRevenueNonCurrent: PERCENT,
    // growthDeferredTaxLiabilitiesNonCurrent: PERCENT,
    // growthOtherNonCurrentLiabilities: PERCENT,
    // growthTotalNonCurrentLiabilities: PERCENT,
    // growthOtherLiabilities: PERCENT,
    // growthTotalLiabilities: PERCENT,
    // growthCommonStock: PERCENT,
    // growthRetainedEarnings: PERCENT,
    // growthAccumulatedOtherComprehensiveIncomeLoss: PERCENT,
    // growthOthertotalStockholdersEquity: PERCENT,
    // growthTotalStockholdersEquity: PERCENT,
    // growthTotalLiabilitiesAndStockholdersEquity: PERCENT,
    // growthTotalInvestments: PERCENT,
    // growthTotalDebt: PERCENT,
    // growthNetDebt: PERCENT,
    // Returns - Cash Flows
    // growthNetIncome: PERCENT, // DUPLICATE
    // growthDepreciationAndAmortization: PERCENT, // DUPLICATE
    // growthStockBasedCompensation: PERCENT,
    // growthChangeInWorkingCapital: PERCENT,
    // growthAccountsReceivables: PERCENT,
    // growthInventory: PERCENT, // DUPLICATE
    // growthAccountsPayables: PERCENT,
    // growthOtherWorkingCapital: PERCENT,
    // growthOtherNonCashItems: PERCENT,
    // growthNetCashProvidedByOperatingActivities: PERCENT,
    // growthInvestmentsInPropertyPlantAndEquipment: PERCENT,
    // growthAcquisitionsNet: PERCENT,
    // growthPurchasesOfInvestments: PERCENT,
    // growthSalesMaturitiesOfInvestments: PERCENT,
    // growthNetCashUsedForInvestingActivities: PERCENT,
    // growthDebtRepayment: PERCENT,
    // growthCommonStockIssued: PERCENT,
    // growthCommonStockRepurchased: PERCENT,
    // growthDeferredIncomeTax: PERCENT,
    // growthDividendsPaid: PERCENT,
    // growthNetCashUsedProvidedByFinancingActivities: PERCENT,
    // growthEffectOfForexChangesOnCash: PERCENT,
    // growthNetChangeInCash: PERCENT,
    // growthCashAtEndOfPeriod: PERCENT,
    // growthCashAtBeginningOfPeriod: PERCENT,
    // growthOperatingCashFlow: PERCENT,
    // growthCapitalExpenditure: PERCENT,
    // growthFreeCashFlow: PERCENT,
    // growthOtherInvestingActivites: PERCENT,
    // growthOtherFinancingActivites: PERCENT,
};

export const filterByType = (obj: any, targetType: any): Partial<any> => {
    const result: Partial<any> = {};

    for (const [property, type] of Object.entries(schema)) {
        if (
            type === targetType ||
            (type === FundamentalValuationsType.INCLUDE && type !== FundamentalValuationsType.METADATA)
        ) {
            result[property] = obj[property];
        }
    }

    return result;
};
